//
//
//
//
//
//
var script = {
  name: 'TransitionExpand',
  props: {
    enterTransition: {
      type: Boolean,
      default: true
    },
    leaveTransition: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    afterEnter(element) {
      if (!this.enterTransition) {
        return;
      }

      element.style.height = 'auto';
    },

    enter(element) {
      if (!this.enterTransition) {
        return;
      }
      /* eslint-disable no-unused-vars */


      const {
        width
      } = getComputedStyle(element);
      /* eslint-disable no-param-reassign */

      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      element.style.height = 'auto';
      /* eslint-enable */

      const {
        height
      } = getComputedStyle(element);
      /* eslint-disable no-param-reassign */

      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;
      /* eslint-enable */
      // Force repaint to make sure the
      // animation is triggered correctly.
      // eslint-disable-next-line no-unused-expressions

      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        // eslint-disable-next-line no-param-reassign
        element.style.height = height;
      });
    },

    leave(element) {
      if (!this.leaveTransition) {
        return;
      }

      const {
        height
      } = getComputedStyle(element); // eslint-disable-next-line no-param-reassign

      element.style.height = height; // Force repaint to make sure the
      // animation is triggered correctly.
      // eslint-disable-next-line no-unused-expressions

      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        // eslint-disable-next-line no-param-reassign
        element.style.height = 0;
      });
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/common/TransitionExpand.vue_rollup-plugin-vue=script.js